import React from 'react'

import { connect } from "react-redux"

import { Form } from 'react-form'

import { Card } from 'primereact/card'

import ClientTable from '../components/client/client-table'
import ClientDetails from '../components/client/client-details'

import * as clientActionCreators from "../actionCreators/client"
import * as appActionCreators from "../actionCreators/app"

import { ROLE_ADMIN } from '../js/const'

class Client extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isDisplayingDialog: false, // determines whether client details dialog is hidden or shown
      selectedClient: {} // determines what client is selcted in the table. It will be highlighted
    }
  }

  // this function will be called when the form is submitted successfully
  // the client object passed is in the same structure as the object bound to <Form> values property
  // the object will have been updated based on user input
  formSubmittedSuccessfully = client => {
    client.StartDate = client.StartDate ? new Date(client.StartDate) : null
    client.EndDate = client.EndDate ? new Date(client.EndDate) : null

    // if id exists then we are updating otherwise we are adding
    // use actionCreators that have been injected in as props. This happens when the higher order component connect is used
    if (client.ClientId) {
      this.saveClient(client, this.props.updateClient)
    } else {
      client.LobbyistId = this.props.lobbyistId
      this.saveClient(client, this.props.addClient)
    }
  }

  // this function will be called when the form is submitted successfully
  // the client object passed is in the same structure as the object bound to <Form> values property
  // the object will have been updated based on user input
  saveClient = (client, save) => {
    this.props.setLoading(true)
      .then(() => save(client))
      .then(response => {
        // set response in store so global response component can handle response
        /*
            response json structure is:
            {
                "$id":"1",
                "SuccessOutput":null,
                "Success":false,
                "ErrorMessages":{
                    "$id":"2",
                    "$values":[
                        "Name is required"
                    ]
                },
                "WarningMessages":{
                    "$id":"3",
                    "$values":[

                    ]
                }
            }
        */
        this.props.setAjaxResponse(response)
        if (response.data.Success) {
          // close dialog by calling function that has been passed in by containing component
          // this is because the state that determines whether the dialog is showing is in the containing component
          this.closeClientDetails()
        }
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  deleteClient = clientId => {
    if (clientId) {
      this.props.setLoading(true)
        .then(() => this.props.deleteClient(clientId))
        .then(response => {
          // set response in store so global response component can handle response
          this.props.setAjaxResponse(response)
          if (response.data.Success) {
            // close dialog by calling function that has been passed in by containing component
            // this is because the state that determines whether the dialog is showing is in the containing component
            this.closeClientDetails()
          }
        })
        .then(() => this.props.setLoading(false))
        .catch((error) => this.props.handleError(error)
          .then(() => this.props.setLoading(false)))
    }
  }

  addClient = () => this.loadAndOpenClientDetails(null)
  selectClient = e => this.loadAndOpenClientDetails(e.data)

  loadAndOpenClientDetails = client => {
    let clientId = client ? client.ClientId : null
    this.props.setLoading(true)
      .then(() => this.props.getClient(clientId))
      .then(() => {
        this.setState({ isDisplayingDialog: true, selectedClient: client || {} })
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  closeClientDetails = (annualReturnClient, resetForm) => {
    if (resetForm) {
      // reset form to initial state to clear validation errors and bound value
      resetForm()
    }

    this.setState({ isDisplayingDialog: false, selectedClient: {} })

    // clear loaded client in store otherwise there is an issue when opening a different lobbyist and the Calendar component where Uncaught TypeError: viewDate.getMonth is not a function
    this.props.clearClient()
  }

  render() {
    // check if current client that is being looked at exists. If not create an empty object to deal with issues that could be caused by client being undefined
    // i.e. when binding to client.Entity.ClientName there could be issues when client is undefined since we are trying to access a property off of a propery
    let currentClient = this.props.client.currentClient ? this.props.client.currentClient : {}
    let clients = this.props.client.lobbyistClients ? this.props.client.lobbyistClients : []
    let isAdd = !currentClient.ClientId
    let isAdmin = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_ADMIN)

    let clientTableProps = {
      canSave: this.props.canSave,
      clients: clients,
      selectClient: this.selectClient,
      addClient: this.addClient,
      selectedClient: this.state.selectedClient,
      isAnnualReturn: false
    }

    return (
      <Card title="Clients" subTitle="If there is no End Date shown then client is current">
        <ClientTable {...clientTableProps} />
        {/* values sets the form state. I'm binding to the props which is linked redux so we can update the store and the form will be reflected
        this is useful when needed to clear the form or populating the form from another component
        onSubmit is called when the form has been submitted and has passed validation
        formApi properties can be found at https://react-form.js.org/#/*/}
        <Form values={currentClient} onSubmit={this.formSubmittedSuccessfully}>
          {formApi => {
            let clientDetailsProps = {
              currentClient: currentClient,
              canSave: this.props.canSave,
              submitForm: formApi.submitForm,
              resetForm: formApi.resetAll,
              isAdd: isAdd,
              deleteClient: this.deleteClient,
              isDisplayingDialog: this.state.isDisplayingDialog,
              closeClientDetails: this.closeClientDetails,
              isAnnualReturn: false,
              isAdmin: isAdmin
            }

            return (
              <ClientDetails {...clientDetailsProps} />
            )
          }}
        </Form>
      </Card>
    )
  }
}

const mapStateToProps = state => {
  let { client, auth } = state
  return { client, auth }
}

// this is how to combine actions available
const actionCreators = {
  ...appActionCreators,
  ...clientActionCreators
}

export default connect(mapStateToProps, actionCreators)(Client);


// WEBPACK FOOTER //
// ./src/container/Client.js